import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const WEBHOOK_ENDPOINTS_QUERY_KEY = "useWebhookEndpointsQuery";

/** Every webhook endpoint of the organization (core caps them at 20). */
export const useWebhookEndpointsQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: [WEBHOOK_ENDPOINTS_QUERY_KEY, apiClient.slug],
    queryFn: async () => apiClient.orgOrOfficeSettings.listWebhookEndpoints(),
    enabled: !!apiClient.slug
  });
};
